const translations = {
    label: 'Flight Group Name'
};

export default translations;
